import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, MenuItem, TextField, InputAdornment, Icon } from "@mui/material";

function RelatedDropDownsField({
  displayNameParent,
  displayNameChild,
  fieldRefParent,
  fieldRefChild,
  relatedOptions,
}) {
  const [parentOptions, setParentOptions] = useState([]);
  const [selectedParentOption, setSelectedParentOption] = useState(null);
  const [childFieldOptions, setChildFieldOptions] = useState([]);

  useEffect(() => {
    const pOts = [];
    for (const row of relatedOptions) {
      pOts.push(row.parent);
    }
    setParentOptions(pOts);
  }, []);

  useEffect(() => {
    if (selectedParentOption === null) {
      return;
    }

    let cOts = [];
    for (const row of relatedOptions) {
      if (row.parent === selectedParentOption) {
        cOts = row.child.split(",");
      }
    }
    setChildFieldOptions(cOts);
  }, [selectedParentOption]);

  return (
    <Box mt={4}>
      <Box>
        <TextField
          select
          fullWidth
          name={fieldRefParent}
          label={displayNameParent}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Icon>checklist</Icon>
              </InputAdornment>
            ),
          }}
          onChange={(e) => setSelectedParentOption(e.target.value)}
        >
          {parentOptions.map((option) => (
            <MenuItem value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Box>
      <Box mt={4}>
        <TextField
          select
          fullWidth
          name={fieldRefChild}
          label={displayNameChild}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Icon>checklist</Icon>
              </InputAdornment>
            ),
          }}
        >
          {childFieldOptions.map((option) => (
            <MenuItem value={option}>{option}</MenuItem>
          ))}
        </TextField>
      </Box>
    </Box>
  );
}

// Typechecking props of the Transaction
RelatedDropDownsField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

RelatedDropDownsField.defaultProps = {
  options: null,
};
export default RelatedDropDownsField;
